import { render, staticRenderFns } from "./speciallistBox.vue?vue&type=template&id=6bd7ae8e&scoped=true&"
import script from "./speciallistBox.vue?vue&type=script&lang=js&"
export * from "./speciallistBox.vue?vue&type=script&lang=js&"
import style0 from "./speciallistBox.vue?vue&type=style&index=0&id=6bd7ae8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd7ae8e",
  null
  
)

export default component.exports